import { render, staticRenderFns } from "./matchHDPOUMLFTOdds.vue?vue&type=template&id=2fa13240&lang=pug&"
import script from "./matchHDPOUMLFTOdds.vue?vue&type=script&lang=js&"
export * from "./matchHDPOUMLFTOdds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports